import { useEffect } from "react";
import { animate } from "motion";

const useRipple = (ref) => {
  useEffect(() => {
    const button = ref.current;
    if (!button) {
      return;
    }

    const darkenColor = (rgbString) => {
      const [r, g, b] = rgbString.match(/\d+/g).map(Number);
      const factor = 0.8;
      const darkerR = Math.max(0, r * factor);
      const darkerG = Math.max(0, g * factor);
      const darkerB = Math.max(0, b * factor);
      return `rgba(${darkerR}, ${darkerG}, ${darkerB}, 0.4)`;
    };

    const showRipple = (e) => {
      const computedStyle = window.getComputedStyle(button);
      const backgroundColor = computedStyle.backgroundColor;

      const ripple = document.createElement("span");
      const rect = button.getBoundingClientRect();
      const size = Math.max(rect.width, rect.height);
      const x = e.clientX - rect.left - size / 2;
      const y = e.clientY - rect.top - size / 2;

      ripple.style.width = ripple.style.height = `${size}px`;
      ripple.style.left = `${x}px`;
      ripple.style.top = `${y}px`;
      ripple.style.backgroundColor = darkenColor(backgroundColor);

      ripple.classList.add("ripple");
      button.appendChild(ripple);

      animate(
        ripple,
        { scale: 2, opacity: 0 },
        { duration: 0.6, ease: "linear" }
      ).finished.then(() => {
        ripple.remove();
      });
    };

    button.addEventListener("mousedown", showRipple);

    return () => {
      if (button) {
        button.removeEventListener("mousedown", showRipple);
      }
    };
  }, [ref.current]);
};

export default useRipple;
